export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "zones.worker.b0006b31bb1f5c26899e.worker.js");
}
